var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLive = function SvgLive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.90039C0 4.93239 4.032 0.900391 9 0.900391C13.968 0.900391 18 4.93239 18 9.90039C18 13.2304 16.191 16.1284 13.5 17.6854L12.6 16.1284C14.751 14.8774 16.2 12.5644 16.2 9.90039C16.2 5.92239 12.978 2.70039 9 2.70039C5.022 2.70039 1.8 5.92239 1.8 9.90039C1.8 12.5644 3.249 14.8774 5.391 16.1284L4.491 17.6854C1.809 16.1284 0 13.2304 0 9.90039ZM14.4 9.90039C14.4 6.92139 11.979 4.50039 9 4.50039C6.021 4.50039 3.6 6.92139 3.6 9.90039C3.6 11.8984 4.689 13.6354 6.3 14.5714L7.2 13.0054C6.129 12.3754 5.4 11.2324 5.4 9.90039C5.4 7.91139 7.011 6.30039 9 6.30039C10.989 6.30039 12.6 7.91139 12.6 9.90039C12.6 11.2324 11.871 12.3754 10.8 13.0054L11.7 14.5714C13.311 13.6354 14.4 11.8984 14.4 9.90039ZM9 8.10039C8.01 8.10039 7.2 8.91039 7.2 9.90039C7.2 10.8904 8.01 11.7004 9 11.7004C9.99 11.7004 10.8 10.8904 10.8 9.90039C10.8 8.91039 9.99 8.10039 9 8.10039Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live.2be66f54.svg";
export { ForwardRef as ReactComponent };